import { trackWithoutThrow } from '@chegg-wt/core/utils/errors'
import { userProjectIdSelector, jwtSelector } from '../user/selectors'

// TODO: Remove when we figure out the underlying issue for citation update/create issues
export const collectUserStateOnAnomaly = (action, state): void => {
  const { user_role, sessionId, cheggUserUuid } = jwtSelector(state)
  trackWithoutThrow(new Error(`Invalid ProjectId value for citation ${action}`), {
    sessionId,
    cheggUserUuid,
    userRole: user_role,
    userProjectId: userProjectIdSelector(state),
    projectState: state.currentProject,
  })
}
